import './LoadingSpinner.css'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function LoadingSpinner({ text }: { text?: string | React.ReactNode }) {
  const { t } = useTranslation()
  const display = text ?? t('loading')
  return (
    <div className="spinner-fullscreen" role="status">
      <div className="loader" />
      <p className="spinner-text">{display}</p>
    </div>
  )
}